import React from 'react';
import { useSelector } from 'react-redux';
import { getSelected } from './slice';
import ImageEditor from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit';
import { ENewTabLayerType } from 'src/types/common/module';
import { get } from 'lodash';
const ResponsiveEditSwitcher = (props) => {
  const data = useSelector(getSelected());
  const type = get(data, 'type');
  const selected = get(data, 'selected');
  const { children, onSubmit, config, onChanged } = props;
  const breakpoint = get(config, 'breakpoint');
  const name = get(data, 'name');

  const renderChild = () => {
    if (type && selected) {
      if (type === ENewTabLayerType.Image) {
        return (
          <ImageEditor
            onSubmit={onSubmit}
            breakpoint={breakpoint}
            onChanged={onChanged}
          />
        );
      }
      if (type === ENewTabLayerType.Poster) {
        return (
          <ImageEditor
            onSubmit={onSubmit}
            isPoster
            breakpoint={breakpoint}
            onChanged={onChanged}
            name={name}
          />
        );
      }
    }
    return children;
  };
  return renderChild();
};
export default ResponsiveEditSwitcher;
